import Modal from "@/components/common/modal";
import { DialogFooter } from "@/components/ui/dialog";
import { cn } from "@/utils/theme";
import { Button, Icon } from "@elaniintc/goes-design-system";

interface Props {
  isOpen: boolean;
  isLoading?: boolean;
  onAccept: () => void;
  onClose: () => void;
}

const DeactivateEmailTemplateModal = ({
  isOpen,
  isLoading,
  onAccept,
  onClose,
}: Props) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Desactivar plantilla"
      description="¿Estás seguro de que deseas desactivar esta plantilla? Se ocultará de la vista principal pero podrás reactivarla más tarde."
      modalContentClassName="max-w-[520px] w-full gap-7"
    >
      <DialogFooter className="pt-1">
        <div className="w-full grid grid-cols-1 tablet:grid-cols-2 gap-3">
          <Button
            size="lg"
            type="button"
            className="w-full rounded-lg"
            variant="tertiary"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancelar
          </Button>
          <Button
            size="lg"
            variant="danger-secondary"
            className="w-full rounded-lg"
            type="button"
            disabled={isLoading}
            onClick={onAccept}
          >
            Desactivar
            {isLoading && (
              <Icon
                type="far"
                name="spinner-third"
                className={cn("text-current", "animate-spin")}
              />
            )}
          </Button>
        </div>
      </DialogFooter>
    </Modal>
  );
};

export default DeactivateEmailTemplateModal;
